module.exports = __webpack_public_path__ + "static/media/truck.0fd5d003.svg";